import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import { logger } from '@/services/logger/logger';
import { useAppSelector } from '@/store/hooks';
import { JOURNEY_TYPES } from '@/constants/constants';

export function usePaymentFailure() {
  const transactionState = useAppSelector(state => state.transaction);
  const currentJourney = useAppSelector(state => state.journeys.journey);

  const journeyNavigate = useJourneyNavigate();
  const navigate = useNavigate();

  const paymentFailure = useCallback(() => {
    function doPaymentFailure(): void {
      try {
        // Based on discussions for DF-428-prize-referrals (and for parity with Classic Donate),
        // direct payments will ALWAYS go to the /failure page, rather than use the failureUrl
        // supplied by the PSL. This gives the user another chance to submit different details
        // with the same transaction stored in state.
        if (transactionState.failureUrl && currentJourney !== JOURNEY_TYPES.DIRECT) {
          logger.info(`Redirecting to failureUrl: ${transactionState.failureUrl}`);
          window.location.href = transactionState.failureUrl;
        } else {
          journeyNavigate('failure');
        }
      } catch (error) {
        logger.error('Error while navigating to step...');
        logger.error(error);
        void navigate('/not-found');
      }
    }

    return doPaymentFailure();
  }, [transactionState.failureUrl, journeyNavigate, navigate, currentJourney]);

  return paymentFailure;
}
